export default __webpack_public_path__ + "static/GEO5_compressed-1d031e7531ca88a43360b3ac21dab225.webp";